// @flow
import React from "react";

type IProps = {
	children: any;
}

export const ScreenReaderOnly = ({children}: IProps) => (
	<div className="sr-only">{children}</div>
);